import React from "react";
export default function MEDIAN() {
  return <div>Excel_MEDIAN</div>;
}
